import { createContext, useContext } from 'react'

export type FormLayout = 'vertical' | 'horizontal' | 'inline'

// A share of a 24-column row, as antd's `labelCol` / `wrapperCol`.
export interface FormCol {
  span?: number
}

export interface FormLayoutValue {
  layout: FormLayout
  labelCol?: FormCol
  wrapperCol?: FormCol
  requiredMark: boolean
}

const DEFAULT_LAYOUT: FormLayoutValue = {
  layout: 'vertical',
  requiredMark: true,
}

export const FormLayoutContext = createContext<FormLayoutValue>(DEFAULT_LAYOUT)

export function useFormLayout(): FormLayoutValue {
  return useContext(FormLayoutContext)
}

export function colWidth(col: FormCol | undefined): string | undefined {
  return col?.span === undefined ? undefined : `${(col.span / 24) * 100}%`
}

// What the enclosing `FormItem` currently shows, for a control that has to
// paint its own error state (a Sutra `Input` takes `$error`).
export const FormItemStatusContext = createContext<
  'error' | 'warning' | 'success' | undefined
>(undefined)

export function useFormItemStatus():
  | 'error'
  | 'warning'
  | 'success'
  | undefined {
  return useContext(FormItemStatusContext)
}
